import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take, filter, timeout } from 'rxjs';
import { AuthService } from '@services/auth';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Skip the initial null and wait for actual auth state
  return authService.user$.pipe(
    filter((user, index) => index > 0 || user !== null), // Skip only first null
    take(1),
    timeout(3000), // Timeout after 3 seconds
    map(user => {
      if (user) {
        return true;
      } else {
        // Redirect to login page with return url
        return router.createUrlTree(['/auth/login'], {
          queryParams: { returnUrl: state.url }
        });
      }
    })
  );
};

export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.user$.pipe(
    take(1),
    map(user => {
      if (user) {
        // Redirect authenticated users to main page
        return router.createUrlTree(['/']);
      } else {
        return true;
      }
    })
  );
};
